import type { ApiClient } from '../client'
import type {
  InviteAcceptRequest,
  LoginRequest,
  PasswordChangeRequest,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
  RevokedSessionsResponse,
  SessionResponse,
} from '../types'

/** src/modules/auth/controllers/auth.controller.ts — refresh is NOT here; see src/auth/refresh.ts. */
export function authEndpoints(api: ApiClient) {
  return {
    login: (body: LoginRequest) =>
      api.post<SessionResponse>('auth/login', body, {
        auth: false,
        retry: { rateLimited: { attempts: 0, maxWaitMs: 0 } },
      }),
    /** 204 whether or not a token was found. */
    logout: () => api.post<undefined>('auth/logout', undefined, { auth: false }),
    acceptInvite: (body: InviteAcceptRequest) =>
      api.post<SessionResponse>('auth/invite/accept', body, { auth: false }),
    changePassword: (body: PasswordChangeRequest) =>
      api.post<RevokedSessionsResponse>('auth/password/change', body),
    /** Always 204 — no enumeration. Note: no mailer is wired in the backend today (FRONTEND_PLAN BE-9). */
    requestPasswordReset: (body: PasswordResetRequest) =>
      api.post<undefined>('auth/password/reset/request', body, { auth: false }),
    confirmPasswordReset: (body: PasswordResetConfirmRequest) =>
      api.post<RevokedSessionsResponse>('auth/password/reset/confirm', body, { auth: false }),
  }
}
